module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-patients-steps"
  }, [_c('div', {
    staticClass: "custom-patients-steps__bg"
  }, [_c('div', {
    staticClass: "custom-patients-steps__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "custom-patients-steps__title",
    class: {
      "custom-patients-steps__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-patients-steps__steps"
  }, [_vm._l((_vm.props.steps), function(step, i) {
    return _c('div', {
      directives: [{
        name: "waypoint",
        rawName: "v-waypoint",
        value: ({
          active: true,
          callback: _vm.onWaypointStep,
          options: _vm.intersectionStepOptions
        }),
        expression: "{ active: true, callback: onWaypointStep, options: intersectionStepOptions }"
      }],
      key: i,
      staticClass: "custom-patients-steps__step",
      class: {
        "custom-patients-steps__step--active": _vm.fadeStep >= i
      }
    }, [_c('div', {
      staticClass: "custom-patients-steps__number"
    }, [_vm._v(_vm._s(i + 1))]), _c('div', {
      staticClass: "custom-patients-steps__content",
      domProps: {
        "innerHTML": _vm._s(step.step)
      }
    })])
  }), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointLine,
        options: _vm.intersectionLineOptions
      }),
      expression: "{ active: true, callback: onWaypointLine, options: intersectionLineOptions }"
    }],
    staticClass: "custom-patients-steps__seperator",
    class: {
      "custom-patients-steps__seperator--active": _vm.fadeLine
    }
  }, [_c('div', {
    staticClass: "custom-patients-steps__orange-line"
  })])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef549fec","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-patients-steps/custom-patients-steps.pug
// module id = 603
// module chunks = 1